const angular = require('angular')
module.exports = [
  '$rootScope', '$stateParams', '$scope', '$utils', 'Message', '$state', '$translate', 'mailFolderService',
  '$phoneModal', '$ionicListDelegate', '$ionicActionSheet', '$ionicScrollDelegate', 'contactService',
  function ($rootScope, $stateParams, $scope, $utils, Message, $state, $translate, mailFolderService,
    $phoneModal, $ionicListDelegate, $ionicActionSheet, $ionicScrollDelegate, contactService) {
    initMailDealing()
    // 初始化往来邮件页
    function initMailDealing() {
      $scope.dealingEmail = $stateParams.contactId || ''
      $scope.dealingName = $stateParams.name || $utils.$email.parse($stateParams.contactId).name
      $scope.title = $translate.instant('MAIL.FOLDER.MAIL_DEALINGS_TITLE', { name: $scope.dealingName })
      $scope.mailDealingFolder = ''
      $scope.msgHandlerDelegate = {} // message函数委托对象
      $scope.dealingMessages = []
      getDealingMails($scope.dealingEmail)
    }

    function updateDealingMessages(data, type) {
      angular.forEach(data, item => {
        item.messageInfo.isStranger = contactService.isStranger(item.messageInfo.from)
      })
      $scope.dealingMessages = type === 'add' ? $scope.dealingMessages.concat(data) : data
    }
    // 获取往来邮件
    function getDealingMails(dealingEmail) {
      $scope.mailDealingFolder = mailFolderService.getMailDealingFolder($scope.dealingEmail)
      $scope.isLoading = true
      $scope.mailDealingFolder.getDealingMails().then(function (data) {
        updateDealingMessages(data)
        if ($scope.dealingMessages.length === $scope.mailDealingFolder.total) {
          $scope.noMoreMessages = true
        }
        if (data.length === 0) {
          $scope.noMail = true
        }
      }, function (data) {
        updateDealingMessages(data)
        $utils.$notify.set({ message: $translate.instant('MAIL.GET_MAILDEALING_FAIL') })
      }).finally(function () {
        $scope.isLoading = false
        $scope.$broadcast('scroll.refreshComplete')
      })
    }
    // 获取更多往来邮件
    $scope.loadMoreMailDealing = function () {
      if ($scope.noMoreMessages) {
        return
      }
      $scope.isSpinnerLoading = true
      $scope.mailDealingFolder.loadMoreDealingMails().then(function (data) {
        updateDealingMessages(data, 'add')
        if ($scope.dealingMessages.length === $scope.mailDealingFolder.total) {
          $scope.noMoreMessages = true
        }
        $ionicScrollDelegate.resize()
      }, function (data) {
        updateDealingMessages(data, 'add')
        $utils.$notify.set({ message: $translate.instant('MAIL.GET_MAILDEALING_FAIL') })
      }).finally(function() {
        $scope.isSpinnerLoading = false
      })
    }
    // 刷新往来邮件
    $scope.refreshMailDealing = function () {
      $scope.isLoading = true
      $scope.mailDealingFolder.getDealingMails({start: 0, limit: $scope.dealingMessages.length}).then(function(data) {
        updateDealingMessages(data)
        if ($scope.dealingMessages.length === $scope.mailDealingFolder.total) {
          $scope.noMoreMessages = true
        }
      }, function(data) {
        $utils.$notify.set({ message: $translate.instant('MAIL.GET_MAILDEALING_FAIL') })
      }).finally(function() {
        $scope.isLoading = false
        $scope.$broadcast('scroll.refreshComplete')
      })
    }
    // 委托读信函数
    $scope.msgHandlerDelegate.readMessage = function (messageItem) {
      let messageId = ''
      messageId = messageItem.messageInfo.id
      $state.go('frame.readDealing', {
        mid: messageId,
        isMailDealings: true,
        name: $scope.dealingName,
        fid: messageItem.messageInfo.fid,
        keyword: $scope.dealingEmail,
        random: Math.random()
      })
    }
    // 委托移动信件函数
    $scope.msgHandlerDelegate.moveMessage = function (MessageItem, mboxa) {
      moveMsgsToFolder([MessageItem], mboxa)
    }
    // 移动单份信件到某一文件夹
    function moveMsgsToFolder(messages, mboxa) {
      $scope.folderHandlerDelegate = {
        selectFolder: function (fid) {
          $scope.selectFolderModal.remove()
          if (messages) {
            $scope.isLoading = true
            mailFolderService.getFolder(fid, mboxa).then(function (oFolder) {
              Message.prototype.moveToFolder(messages, oFolder, mboxa).then(function (data) {
                let sMessage = $translate.instant('MAIL_OP_TIPS.SUCCESS_MOVE')
                sMessage = sMessage.replace('{0}', messages.length).replace('{0}', oFolder.name)
                $utils.$notify.set({ message: sMessage })
              })
            }, function (reason) {
              $utils.$notify.set({ message: $translate.instant('MAIL_OP_TIPS.MOVE_FAILED') })
            }).finally(function () {
              $scope.isLoading = false
            })
          }
        }
      }
      openSelectFolderModal('move', mboxa)
    }
    // 打开文件夹选择模态框
    function openSelectFolderModal(action, mboxa) {
      $ionicListDelegate.closeOptionButtons()
      $scope.selectFolderModal = $phoneModal.fromTemplate(require('views/mail/folders-frame.html'), {
        scope: $scope,
        animation: 'slide-in-right'
      })

      mailFolderService.listFolders(mboxa).then(function (folders) {
        $scope.topFolderWrappers = folders.topFolders
        $scope.otherFolderWrappers = folders.otherFolders
        $utils.$modalFunc.prepareModalBack($scope.folderModal, 'hide')
        $scope.selectFolderModal.show()
      })
    }
    // 委托信件删除函数
    $scope.msgHandlerDelegate.removeMessages = function (messageItemList, mboxa) {
      let msgFid = ''
      if (messageItemList && angular.isArray(messageItemList)) {
        msgFid = messageItemList[0].messageInfo.fid
      }
      $ionicActionSheet.show({
        titleText: $translate.instant(msgFid === 4 ? 'MAIL_OP_TIPS.ALERT_REAL_DELETE' : 'MAIL_OP_TIPS.ALERT_MAIL_DELETE'),
        destructiveText: "<p class='actionText'>" + $translate.instant('OP.DELETE') + '</p>',
        cancelText: $translate.instant('OP.CANCEL'),
        destructiveButtonClicked: function () {
          Message.prototype.remove(messageItemList, mboxa).then(function (data) {
            let tips = msgFid == 4 ? 'MAIL_OP_TIPS.SUCCESS_REAL_DELETE' : 'MAIL_OP_TIPS.SUCCESS_DELETE'
            tips = $translate.instant(tips, { number: 1 })
            $utils.$notify.set({ message: tips })
          }, function () {
            $utils.$notify.set({ message: $translate.instant('OP.DELETE_FAIL') })
          }).finally(function() {
            $scope.refreshMailDealing()
          })
          return true
        },
        cancel: function () {
        }
      })
    }
    // 返回
    $scope.backToDetail = function () {
      window.history.go(-1)
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/mailDealingCtrl.js